module.exports = __webpack_public_path__ + "static/media/50x50-01.adf2b6e7.png";